import LetrexRoot from './Root.vue';
import LetrexCreate from './views/LetrexCreate.vue';
import LetrexEdit from './views/LetrexEdit.vue';
import LetrexList from './views/LetrexList.vue';

export default {
  path: 'gerador/letrex',
  name: 'admin-letrex',
  component: LetrexRoot,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-letrex-list',
      component: LetrexList,
    },
    {
      path: 'novo/',
      name: 'admin-letrex-new',
      component: LetrexCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-letrex-edit',
      component: LetrexEdit,
    },
  ],
};
